import React from 'react';
import {Box} from '@mui/material';
import {Link} from 'react-router-dom';
import {NAVY, TEXTE, TEXTE_SECONDAIRE} from '../../tokens.js';
import {carteSx, libelleCarteSx} from '../dashboard/dashStyles.js';

// Lot 10 : carte d'analyse = titre, pastille de source, UNE phrase de constat calculée, un visuel, un lien vers la carte.
// `source` : 'reel' (navy) | 'simule' (gris) | 'mixte'. `signal` : mention en petit (signal injecté dans la simulation).

const PASTILLES = {
    reel: {libelle: 'Données réelles', fond: NAVY, texte: '#FFFFFF'},
    simule: {libelle: 'Données simulées', fond: '#E6EAEE', texte: '#4A525C'},
    // Lot 12 : population réelle (INSEE), tonnage simulé.
    mixte: {libelle: 'Population réelle · tonnage simulé', fond: '#E6EAF5', texte: NAVY},
};

export default function CarteAnalyse({id, titre, source, constat, signal, lienCarte, pleineLargeur = false, children}) {
    const p = PASTILLES[source] || PASTILLES.reel;
    return (
        <Box component="section" aria-labelledby={id} data-source={source} sx={{...carteSx, p: '16px 20px', display: 'flex', flexDirection: 'column', gap: '12px', minWidth: 0, ...(pleineLargeur ? {gridColumn: '1 / -1'} : {})}}>
            <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px'}}>
                <Box component="h2" id={id} sx={{...libelleCarteSx, m: 0}}>{titre}</Box>
                <Box component="span" sx={{flex: '0 0 auto', height: 22, px: '10px', display: 'inline-flex', alignItems: 'center', borderRadius: '999px', fontSize: 11, fontWeight: 700, backgroundColor: p.fond, color: p.texte}}>{p.libelle}</Box>
            </Box>
            <Box component="p" sx={{m: 0, fontSize: 15, fontWeight: 600, lineHeight: 1.4, color: TEXTE}}>{constat}</Box>
            <Box sx={{flex: '1 1 auto', minWidth: 0}}>{children}</Box>
            {signal && <Box component="p" sx={{m: 0, fontSize: 11, color: TEXTE_SECONDAIRE}}>{signal}</Box>}
            {lienCarte && (
                <Box component={Link} to={lienCarte} sx={{alignSelf: 'flex-start', fontSize: 13, fontWeight: 700, color: NAVY, textDecoration: 'none', '&:hover': {textDecoration: 'underline'}}}>
                    Voir sur la carte →
                </Box>
            )}
        </Box>
    );
}
